export const META_PIXEL_ID =
  (import.meta.env.VITE_META_PIXEL_ID as string | undefined) || "984242297910220";

declare global {
  interface Window {
    fbq?: FbqFunction;
    _fbq?: FbqFunction;
  }
}

type FbqFunction = {
  (...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[];
  loaded: boolean;
  version: string;
  push: FbqFunction;
};

function getFbq(): FbqFunction | undefined {
  if (typeof window === "undefined") return undefined;
  return typeof window.fbq === "function" ? window.fbq : undefined;
}

export function trackMetaPageView() {
  getFbq()?.("track", "PageView");
}

export function trackMetaEvent(eventName: string, params?: Record<string, unknown>) {
  const fbq = getFbq();
  if (!fbq) return;
  if (params) fbq("track", eventName, params);
  else fbq("track", eventName);
}

export { shouldTrackAnalytics as shouldTrackMetaPixel } from "./tracking";
